/* eslint-disable max-len */
import React from "react"
import config from "../../../../../config"

function LogoPreview({ auctionData, context }) {
    const leftLogo = auctionData?.event_display?.left_logo_image
    const rightLogo = auctionData?.event_display?.right_logo_image
    return (
        <div className="flex pb-4">
            {leftLogo && typeof leftLogo === 'string' ?
                <img src={leftLogo.startsWith('blob:') ? leftLogo : `${config.Storage.CDN}${leftLogo}`} 
                    className="max-w-[100px] max-h-[60px] object-contain" alt="Left Logo"
                    data-testid={`${context}-leftLogo`} />
                : <div className="px-3 py-2 bg-gray-200 font-bold flex justify-center items-center">Left Logo</div>
            }
            <div className="flex-grow" />
            {rightLogo && typeof rightLogo === 'string' ?
                <img src={rightLogo.startsWith('blob:') ? rightLogo : `${config.Storage.CDN}${rightLogo}`} 
                    className="max-w-[100px] max-h-[60px] object-contain" alt="Right Logo"
                    data-testid={`${context}-rightLogo`} />
                : <div className="px-3 py-2 bg-gray-200 font-bold flex justify-center items-center">Right Logo</div>
            }
        </div>
    )
}

function LeaderBoardPreview({ auctionData }) {
    const backgroundColor = auctionData?.event_display?.background_color || '#ffffff'
    const backgroundImage = auctionData?.event_display?.background_image
    return (
        <>
            <div className="p-6">
                <div
                    className="px-12 py-12 relative bg-cover"
                    data-testid="leaderboardPreview"
                    style={{
                        backgroundColor,
                        backgroundImage: backgroundImage && typeof backgroundImage === 'string' && backgroundImage.trim() !== '' 
                            ? `url(${backgroundImage.startsWith('blob:') ? backgroundImage : `${config.Storage.CDN}${backgroundImage}`})` 
                            : 'none',
                        aspectRatio: '16/9'
                    }}
                >
                    <LogoPreview auctionData={auctionData} context="leaderboard" />
                    <div className="flex flex-col gap-[21px]">
                        {[1, 2, 3].map((item, index) => (
                            <div key={item} className="flex items-center h-[100px] rounded-lg w-full shadow-md border-[0.2px] border-white-600">
                                <div className="w-[100px] h-full bg-black flex flex-col items-center justify-center rounded-l-md">
                                    <div className="text-sm text-white font-bold">Lot {item}</div>
                                </div>
                                <div className="w-[200px] h-full bg-gray-200 border-r-[1px] border-r-gray-600
                                flex flex-col items-center justify-center gap-1 "
                                >
                                    <div className="text-ls font-bold">CURRENT BID</div>
                                    <div className="text-lg font-semibold text-gray-700">£££,£££</div>
                                    <div className="text-xs">PADDLE {item}</div>
                                </div>
                                <div className="h-full flex-grow bg-white text-lg font-medium flex items-center justify-center">
                                    Lot Title
                                </div>
                                <div className="h-full">
                                    <img
                                        className="w-[169px] h-full rounded-r-lg"
                                        src="/images/placeholder.png"
                                        alt="Lot Image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="absolute bottom-16 right-16 text-white">
                        <span className="text-xs">{"Powered by "}</span>
                        <span className="text-lg font-bold">Indy</span>
                        <span className="text-lg font-normal">.auction</span>
                    </div>
                </div>
                <div className="h-[80px]" />
            </div>
        </>
    )
}

function CarouselPreview({ auctionData }) {
    const backgroundColor = auctionData?.event_display?.background_color || '#ffffff'
    const backgroundImage = auctionData?.event_display?.background_image
    return (
        <div className="p-6">
            <div
                className="px-12 py-12 relative bg-cover"
                data-testid="carouselPreview"
                style={{
                    backgroundColor,
                    backgroundImage: backgroundImage && typeof backgroundImage === 'string' && backgroundImage.trim() !== '' 
                        ? `url(${backgroundImage.startsWith('blob:') ? backgroundImage : `${config.Storage.CDN}${backgroundImage}`})` 
                        : 'none',
                    aspectRatio: '16/9'
                }}
            >
                <LogoPreview auctionData={auctionData} context="carousel" />
                <div className="flex px-5 h-[350px] relative">
                    <div className="flex items-center rounded-lg w-[300px] h-full flex-col">
                        <div className="w-full h-[80px] bg-black flex flex-col items-center justify-center rounded-tl-[14px]">
                            <div className="text-sm text-white font-bold">Lot Title</div>
                        </div>
                        <div className="w-full flex-grow bg-[#F4F4F5] text-lg font-medium flex items-center justify-center
                        border-l-[1px] border-b-[1px] border-gray-600">
                            Description
                        </div>
                        <div className="w-full flex-grow bg-[#F4F4F5] 
                        border-l-[1px] border-gray-600 border-b-[1px] rounded-bl-[14px]
                        flex flex-col items-center justify-center gap-1"
                        >
                            <div className="text-ls font-bold">CURRENT BID</div>
                            <div className="text-lg font-semibold text-[#717179]">£££,£££</div>
                            <div className="text-xs">PADDLE 1</div>
                        </div>
                    </div>
                    <img
                        className="h-full flex-grow border-[1px] border-l-0 border-gray-600 rounded-r-[14px]"
                        src="/images/placeholder.png"
                        alt="Lot Image"
                    />
                    <div className="absolute -top-2 -right-1 h-[50px] px-5 bg-black flex flex-col 
                    items-center justify-center rounded-md border-[0.5px] border-white-600">
                        <div className="text-lg text-white font-bold">Lot 1</div>
                    </div>
                </div>
                <div className="absolute bottom-16 right-16 text-white">
                    <span className="text-xs">{"Powered by "}</span>
                    <span className="text-lg font-bold">Indy</span>
                    <span className="text-lg font-normal">.auction</span>
                </div>
            </div>
        </div>
    )
}
    
export default function EventDisplayPreview({ auctionData, height }) {
    // Safety check for older auctions that might not have event_display data
    const eventDisplay = auctionData?.event_display || {}
    const enableLeaderboard = eventDisplay.enable_leaderboard
    const enableCarousel = eventDisplay.enable_carousel
    
    return (
        <div className={`flex-grow ${height} overflow-x-hidden overflow-y-auto customScrollbar`}>
            {enableLeaderboard && (
                <LeaderBoardPreview auctionData={auctionData} />
            )}

            {enableCarousel && (
                <CarouselPreview auctionData={auctionData} />
            )}
        </div>
    )
}